import React from 'react';
import {
  titleUI,
  yesNoUI,
  yesNoSchema,
  checkboxGroupUI,
  checkboxGroupSchema,
} from 'platform/forms-system/src/js/web-component-patterns';

const isCustodian = formData =>
  formData?.claimantRelationship === 'CUSTODIAN_FILING_FOR_CHILD_UNDER_18';

const needsIncomeRecipients = formData =>
  formData?.hasIncomeToReport === true &&
  formData?.claimantRelationship !== 'SURVIVING_CHILD';

const incomeRecipients = {
  claimant: 'Yours',
  spouse: 'Your spouse',
  child: 'Veteran’s child in your care',
};

const IncomeDescription = () => (
  <>
    <p>Your income is how much you earn.</p>
    <p>These are types of income:</p>
    <ul>
      <li>Your Social Security benefits</li>
      <li>Your investment and retirement payments</li>
      <li>Any income your dependents receive.</li>
    </ul>
  </>
);

const recipientsUI = checkboxGroupUI({
  title: 'Who receives income?',
  description:
    'If you care for more than one dependent child, choose one child and report only that child’s income.',
  required: needsIncomeRecipients,
  labels: incomeRecipients,
  expandUnder: 'hasIncomeToReport',
  expandUnderCondition: true,
  hideIf: formData => !needsIncomeRecipients(formData),
});

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI('Income sources', IncomeDescription),
    hasIncomeToReport: yesNoUI('Do you have income to report?'),
    'view:incomeRecipients': {
      ...recipientsUI,
      spouse: {
        ...recipientsUI.spouse,
        'ui:options': {
          ...recipientsUI.spouse['ui:options'],
          hideIf: formData => !isCustodian(formData),
        },
      },
    },
  },
  schema: {
    type: 'object',
    required: ['hasIncomeToReport'],
    properties: {
      hasIncomeToReport: yesNoSchema,
      'view:incomeRecipients': checkboxGroupSchema(
        Object.keys(incomeRecipients),
      ),
    },
  },
};
